import type { Command } from 'commander';
import { registerJobsSearch } from './search';
import { registerJobsView } from './view';

export function registerJobsCommand(program: Command): void {
	const jobs = program.command('jobs').description('Search and view public job listings');
	registerJobsSearch(jobs);
	registerJobsView(jobs);
}
